module.exports = __webpack_public_path__ + "media/images/faq/infl5-5e75e6658534b0cab52a31e7926c027c.png";